const getters = {
  token: state => state.user.token,
  roles: state => state.user.roles,
  user: state => state.user.user,
  clientid: state => state.user.clientid,
  map: state => state.map.map,
  mapLayer: state => state.map.mapLayer,
  layerComponent: state => state.map.layerComponent,
  isPoint: state => state.map.isPoint,
  lcRightBar: state => state.map.lcRightBar,
  isBase: state => state.map.isBase,
  layerIndexId: state => state.map.layerIndexId,
  bottomList: state => state.map.bottomList,
  hasmap: state => state.map.hasmap,
  ggMap: state => state.map.ggMap,
  layerCode: state => state.map.layerCode,
  hoverName: state => state.map.hoverName,
  mapComponent: state => state.map.mapComponent,
  seleNav: state => state.map.seleNav,
  baiduShow: state => state.map.baiduShow,
  ssgjShow: state => state.map.ssgjShow,
  granaryIndex: state => state.map.granaryIndex,
  maptype: state => state.map.maptype,

  drawerComponent: state => state.drawer.drawerComponent,
  navComponent: state => state.drawer.navComponent,
  rightComponent: state => state.drawer.rightComponent,
  rightComponentBak: state => state.drawer.rightComponentBak,
  leftComponent: state => state.drawer.leftComponent,
  videoList: state => state.drawer.videoList,
  photoShow: state => state.drawer.photoShow,
  graphic: state => state.drawer.graphic,
  qxzInfo: state => state.drawer.qxzInfo,
  xjCompentent: state => state.drawer.xjCompentent,
  breedCompentent: state => state.drawer.breedCompentent,
  oldCompentent: state => state.drawer.oldCompentent,
  rightMx: state => state.drawer.rightMx,

  mxContent: state => state.drawer.mxContent,
  equipId: state => state.drawer.equipId,
  equipItem: state => state.drawer.equipItem,
  imgShow: state => state.drawer.imgShow,
  imgArr: state => state.drawer.imgArr,
  leftDs: state => state.drawer.leftDs,
  rightDs: state => state.drawer.rightDs,
  seleIndex: state => state.drawer.seleIndex,
  fromPath: state => state.drawer.fromPath
};
export default getters;
